<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="生成积分" name="card">
        <tab-card :visible="activeName === 'card'"></tab-card>
      </el-tab-pane>
      <el-tab-pane label="积分记录" name="log">
        <tab-log :visible="activeName === 'log'"></tab-log>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabCard from "./card.vue";
import tabLog from "./log.vue";
export default {
  components: {
    tabCard,
    tabLog,
  },
  data() {
    return {
      activeName: "card",
    };
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  /deep/.el-tabs__active-bar {
    transition: none;
  }
}
</style>
